import fetchBase from '../api/fetchBase';
import useAuth from './useAuth';

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const refresh = async () => {
    try {
      // Send a request to the token refresh endpoint
      const response = await fetchBase('/auth/refresh', { method: 'GET', credentials: 'include' });
      const data = await response.json();
      // Extract the new access token from the response
      const { accessToken: newAccessToken } = data;
      setAuth((prev) => ({
        ...prev,
        accessToken: newAccessToken,
      }));
      return newAccessToken;
    } catch (error) {
      throw new Error('Failed to refresh access token');
    }
  };
  return refresh;
};

export default useRefreshToken;
